import SessionTemplate from './SessionTemplate';

export default SessionTemplate;
